import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const followersDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_Followers: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_Followers: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
